import React from "react";

function AboutUsHeader() {
  return (
    <div className="about-us-header">
      <div className="lawone-header-aboutus">درباره ما</div>
      <span className="icon-logo" />
      <div className="lawone-name">لاوین</div>
      <div className="lawone-fullname">دفتر مجازی وکلای دادگستری ایران </div>
    </div>
  );
}

export default AboutUsHeader;
